import { PowerBlockType } from './block';

export const getPowerBlockMap: () => {
  [key in PowerBlockType]: string;
} = () => {
  return {
    rocket: 'icon.rocket.horizontal.png',
    bomb: 'icon.bomb.png',
    cube: 'power/block.cube.all.png',
  };
};
